
import PlayRemove from "../../../assets/outline/PlayRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PlayRemoveIcon({ className, dataTestid = "PlayRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PlayRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
